import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import Text from '../../../shared/components/basic/Text';

export default function EncargoBar({
  handleChange,
  lentesTiposPvps,
  lenteTipoPvp,
  loading,
}) {
  const drawEncargosOptions = (lentesTiposPvps) => {
    const lentesTiposPvpSimple = lentesTiposPvps.filter(e => e.posicion === 0);
    const lentesTiposPvpCoincideCliente = lentesTiposPvps.filter(e => e.coincideCliente && e.posicion !== 0);
    const lentesTiposPvpNoCoincideCliente = lentesTiposPvps.filter(e => !e.coincideCliente && e.posicion !== 0);

    const lentesTiposPvpSimpleOptions = lentesTiposPvpSimple.map(lenteTipoPvp => (
      <Select.Option
        key={lenteTipoPvp.id}
        value={lenteTipoPvp.id}
      >
        {lenteTipoPvp.descripcion}
      </Select.Option>
    ));
    const lentesTiposPvpCoincideClienteOptions = (
      <Select.OptGroup label="Promoción">
        {lentesTiposPvpCoincideCliente.map(lenteTipoPvp => (
          <Select.Option
            key={lenteTipoPvp.id}
            value={lenteTipoPvp.id}
          >
            {lenteTipoPvp.descripcion}
          </Select.Option>
        ))}
      </Select.OptGroup>
    );
    const lentesTiposPvpNoCoincideClienteOptions = (
      <Select.OptGroup label="Promoción">
        {lentesTiposPvpNoCoincideCliente.map(lenteTipoPvp => (
          <Select.Option
            key={lenteTipoPvp.id}
            value={lenteTipoPvp.id}
          >
            {lenteTipoPvp.descripcion}
          </Select.Option>
        ))}
      </Select.OptGroup>
    );
    return lentesTiposPvpSimpleOptions
      .concat(lentesTiposPvpCoincideClienteOptions)
      .concat(lentesTiposPvpNoCoincideClienteOptions);
  };
  return (
    <div style={{marginLeft: 16}}>
      <Text mr={12}>Encargo: </Text>
      <Select
        showSearch
        value={lenteTipoPvp ? lenteTipoPvp.id : undefined}
        placeholder="Sel. pack"
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        style={{ width: 142 }}
        onChange={handleChange}
        loading={loading}
      >
        {drawEncargosOptions(lentesTiposPvps)}
      </Select>
    </div>
  );
}

EncargoBar.propTypes = {
  handleChange: PropTypes.func,
  lentesTiposPvps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    descripcion: PropTypes.string,
  })).isRequired,
  loading: PropTypes.bool,
};
EncargoBar.defaultProps = {
  handleChange: () => {},
  loading: false,
};
